<template>
    <img
        class="achievement-gem-image"
        :src="src"
        :alt="`${rarity} achievement`"
        :title="rarity" />
</template>

<script>
import { gemNameForRarity } from '../../globals/rarityEmojis.js'

/**
 * The gem for an achievement's rarity tier, from the Gems icon set.
 *
 * These are the same five files the bot uploads as application emojis
 * (`RARITY_EMOJIS` in `types/util/emojis.js`), so an achievement unlocked in a
 * Discord channel carries the same gem as the one on the profile page. The
 * mapping is mirrored in `globals/rarityEmojis.js` with a test guarding the
 * two against drift.
 *
 * Item rewards on the season track use `RarityGem.vue` instead — a flat SVG
 * that stays readable at 2rem with fifty of them in a row.
 *
 * The requires are written out rather than built from the name so webpack
 * resolves five static paths — a missing asset then fails the build instead of
 * rendering a broken image.
 */
const GEM_IMAGES = {
    gem2_color1: require('@/assets/images/rarity/256w/gem2_color1.png'),
    gem5_color4: require('@/assets/images/rarity/256w/gem5_color4.png'),
    gem8_color5: require('@/assets/images/rarity/256w/gem8_color5.png'),
    gem8_color1: require('@/assets/images/rarity/256w/gem8_color1.png'),
    gem6_color2: require('@/assets/images/rarity/256w/gem6_color2.png'),
}

export default {
    name: 'AchievementGem',
    props: {
        rarity: {
            type: String,
            default: 'rare',
        },
    },
    computed: {
        src() {
            return GEM_IMAGES[gemNameForRarity(this.rarity)]
        },
    },
}
</script>

<style scoped lang="scss">
.achievement-gem-image {
    display: block;
    // Callers size this by setting width and height. The gems aren't all the
    // same aspect ratio, so contain keeps each one whole inside whatever box
    // it is given rather than stretching it.
    object-fit: contain;
}
</style>
